/**
 * For now this only has very basic functionality but there are more convenient features we could add this
 * setFocus is called by child directives and this manager determines whether to apply it or not
 */

/**
 * example:
 *   <div apt-autofocus-manager>
 *     <input apt-auto-focus-if='$ctrl.isEditable'>
 *     <select apt-auto-focus-if='$ctrl.isEditable'>
 *   </div>
 */

/**
 * TODO
 * add autofocus on a field based on first enabled input element found
 * add autofocus to fist input element failing validation
 */
export default function AutoFocusManagerDirective($timeout) {
  'ngInject';

  return {
    restrict: 'A',
    controller: class {
      isFocusSet = false;

      constructor() {
        //
      }

      setFocus(el) {
        if (!this.isFocusSet) {
          el.focus();
          this.isFocusSet = true;
        }
      }
    }
  };
}
